import { PaymentMethodType } from '../../services/PaymentManager.types'

export const PAYMENT_METHOD_ORDER = [
  'apple_pay',
  'google_pay',
  'external_paypal',
  'card',
]

// List of payment methods that appear in stripe PaymentElement but charging them is done outside of it (for example Apple Pay or PayPal payment buttons)
export const ExternalToPaymentMethod: Record<string, PaymentMethodType> = {
  external_paypal: PaymentMethodType.PAYPAL,
  apple_pay: PaymentMethodType.APPLE_PAY,
  google_pay: PaymentMethodType.GOOGLE_PAY,
}

export function isExternalPaymentMethod(stripePaymentMethod: string): boolean {
  return Object.keys(ExternalToPaymentMethod).includes(stripePaymentMethod)
}
